export interface Bounds {
    minX: number,
    minY: number,
    minZ: number,
    maxX: number,
    maxY: number,
    maxZ: number
}

export function getBounds<T>(...coordinates: T[]): Bounds {
    const coordinatesX = [].concat(...coordinates).map((c) => c[0]);
    const coordinatesY = [].concat(...coordinates).map((c) => c[1]);
    const coordinatesZ = [].concat(...coordinates).map((c) => isNaN(c[2]) ? 0 : c[2]);

    return {
        minX: Math.min(...coordinatesX),
        minY: Math.min(...coordinatesY),
        minZ: Math.min(...coordinatesZ),
        maxX: Math.max(...coordinatesX),
        maxY: Math.max(...coordinatesY),
        maxZ: Math.max(...coordinatesZ),
    };
}
